import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  useTheme
} from "@mui/material";

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const METRICS = ["TWR", "SHARPE", "SORTINO", "LARGEST DRAWDOWN"];

const AnnualPerformanceTable = ({ data = [] }) => {
  const theme = useTheme();

  const getValueColor = (value, isMetric = false) => {
    if (value === null || value === undefined || value === 0) {
      return theme.palette.text.disabled;
    }
    if (value > 0) {
      return theme.palette.success.main;
    }
    return theme.palette.error.main;
  };

  const formatValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "number") {
      return `${value.toFixed(2)}%`;
    }
    return value;
  };

  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          backgroundColor: theme.palette.background.paper,
          overflowX: "hidden"
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: theme.palette.primary.main,
                "& th": {
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "0.875rem",
                  padding: "12px 8px",
                  textAlign: "center",
                  whiteSpace: "nowrap"
                }
              }}
            >
              <TableCell sx={{ textAlign: "left", minWidth: 80, color: "#ffffff" }}>YEAR</TableCell>
              {MONTHS.map((month) => (
                <TableCell key={month} sx={{ color: "#ffffff" }}>{month}</TableCell>
              ))}
              {METRICS.map((metric) => (
                <TableCell key={metric} sx={{ color: "#ffffff" }}>{metric}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow
                key={row.year}
                sx={{
                  "&:nth-of-type(odd)": {
                    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)"
                  },
                  "&:hover": {
                    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"
                  },
                  "& td": {
                    padding: "12px 8px",
                    fontSize: "0.875rem",
                    textAlign: "center"
                  }
                }}
              >
                <TableCell
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                    textAlign: "left"
                  }}
                >
                  {row.year}
                </TableCell>

                {MONTHS.map((month) => {
                  const monthKey = month.toLowerCase();
                  const value = row.months?.[monthKey];

                  return (
                    <TableCell
                      key={`${row.year}-${month}`}
                      sx={{
                        color: getValueColor(value),
                        fontWeight: value !== null && value !== undefined ? 500 : 400
                      }}
                    >
                      {formatValue(value)}
                    </TableCell>
                  );
                })}

                
                {METRICS.map((metric) => {
                  const metricKey = metric.toLowerCase().replace(/\s+/g, "_");
                  const value = row.metrics?.[metricKey];
                  return (
                    <TableCell
                      key={`${row.year}-${metric}`}
                      sx={{
                        color: getValueColor(value, true),
                        fontWeight: value !== null && value !== undefined ? 600 : 400
                      }}
                    >
                      {formatValue(value)}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AnnualPerformanceTable;
